import React from "react";
import Moment from "react-moment";
import { useNavigate } from "react-router-dom";
import useFetch from "../../../../ApiClient/GetApi";
import { BASE_URL } from "../../../../Utils/urls";
import Header from "../../layout/Header";


export default function BeforePayment() {
    const navigate = useNavigate();
    const { data } = useFetch(`booking/before_payment/${localStorage.getItem("orderId")}`);
    const order_details2 = () =>{
        navigate("/order_details2");
    }

    const tdStyle2 = "font-normal text-base text-black text-opacity-60 py-2";
    const tdStyle3 = "font-normal text-base text-black py-2 sm:pl-16 pl-6";

    return (
        <>
            <section className="font-soehne">
                <Header />
                <section className="w-full bg-themeGray py-16 space-y-4">
                    <div className="grid grid-cols-1 gap-x-4 gap-y-4 w-4/5 mx-auto">

                        <div className="grid grid-cols-4">
                            <div>
                                <p className="font-medium sm:text-xl text-xl text-themeBlue">Package Invoice</p>
                                <p className="text-themeGray3">Order#{data?.data?.booking?.id ?? ""}</p>
                            </div>
                            <div>
                                <p className="font-medium sm:text-xl text-xl text-themeBlue"><Moment format="D MMM , YYYY hh:mm a">{data?.data?.booking?.expectedHubArrivalDate}</Moment></p>
                                <p className="text-themeGray3">Excepted Hub Arrival Date</p>
                            </div>
                            <div>
                                <p className="font-medium sm:text-xl text-xl text-themeBlue">12345678</p>
                                <p className="text-themeGray3">Expected CONSOL Number</p>
                            </div>
                            <div>
                                <a target="_blank" href={BASE_URL + data?.data?.booking?.Invoice?.invoice} className="font-medium sm:text-xl text-xl text-themeBlue">Download Invoice</a>

                            </div>
                        </div>
                        <div className="bg-white py-6 px-5 rounded-lg space-y-4 ">

                            <div className="flex justify-between items-center ">
                                <h1 className="font-medium sm:text-2xl text-xl text-themeBlue ml-14">
                                    Package Details
                                </h1>

                            </div>
                            {
                                data?.data?.booking?.Packages?.map((pkg) => (
                                    <div className="block border-2 p-2 rounded-lg" >
                                        <table className="w-full">
                                            <tbody>







                                                <tr>
                                                    <td className={tdStyle3}>DIMENSIONS</td>
                                                    <td className={tdStyle3}>Length (cm)</td>
                                                    <td className={tdStyle3}>Width (cm)</td>
                                                    <td className={tdStyle3}>Height (cm)</td>
                                                    <td className={tdStyle3}>Weight (kg)</td>
                                                </tr>

                                                <tr>
                                                    <td className={tdStyle3}>Captured</td>
                                                    <td className={tdStyle3}>{pkg.captureLength}</td>
                                                    <td className={tdStyle3}>{pkg.captureWidth}</td>
                                                    <td className={tdStyle3}>{pkg.captureHeight}</td>
                                                    <td className={tdStyle3}>{pkg.captureWeight}</td>



                                                </tr>


                                                <tr>
                                                    <td className={tdStyle3}>Captured</td>
                                                    <td className={tdStyle3}>{pkg.measuredLength}</td>
                                                    <td className={tdStyle3}>{pkg.measuredWidth}</td>
                                                    <td className={tdStyle3}>{pkg.measuredHeight}</td>
                                                    <td className={tdStyle3}>{pkg.measuredWeight}</td>

                                                </tr>



                                            </tbody>
                                        </table>
                                    </div>
                                ))
                            }




                        </div>
                        <div className="bg-white py-6 px-5 rounded-lg space-y-4 ">

                            <div className="flex justify-between items-center ">
                                <h1 className="font-medium sm:text-2xl text-xl text-themeBlue ml-14">
                                    Product Details
                                </h1>

                            </div>
                            {
                                data?.data?.booking?.Products?.map((product) => (
                                    <div className="block border-2 p-2 rounded-lg" >
                                        <table className="w-full">
                                            <tbody>







                                                <tr>
                                                    <td className={tdStyle3}>DIMENSIONS</td>
                                                    <td className={tdStyle3}>Quantity </td>
                                                    <td className={tdStyle3}>HsCode</td>
                                                    <td className={tdStyle3}>Country</td>
                                                    <td className={tdStyle3}>Weight (kg)</td>
                                                </tr>

                                                <tr>
                                                    <td className={tdStyle3}>Captured</td>
                                                    <td className={tdStyle3}>{product.qty}</td>
                                                    <td className={tdStyle3}>{product.HsCode?.HsCode}</td>
                                                    <td className={tdStyle3}>{product.Country?.name??""}</td>
                                                    <td className={tdStyle3}>{product.weight}</td>



                                                </tr>






                                            </tbody>
                                        </table>
                                    </div>
                                ))
                            }

                        </div>


                    </div>
                    <div className="grid grid-cols-2 gap-x-4 gap-y-4 w-4/5 mx-auto">


                        <div className="bg-white py-6 px-5 rounded-lg space-y-4">
                            <div className="flex justify-between items-center gap-x-4">
                                <h1 className="font-medium sm:text-2xl text-xl text-themeBlue">
                                    Send Package to Below Address
                                </h1>

                            </div>
                            <div className="block" >
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className={tdStyle2}>Company</td>
                                            <td className={tdStyle3}>{data?.data?.booking?.DestinationDetail?.companyName??""}</td>
                                        </tr>
                                        <tr>
                                            <td className={tdStyle2}>Address</td>
                                            <td className={tdStyle3}>{data?.data?.booking?.DestinationDetail?.address??""}</td>
                                        </tr>
                                        <tr>
                                            <td className={tdStyle2}>Country</td>
                                            <td className={tdStyle3}>{data?.data?.booking?.DestinationDetail?.country??""}</td>
                                        </tr>
                                        <tr>
                                            <td className={tdStyle2}>Email</td>
                                            <td className={tdStyle3}>{data?.data?.booking?.DestinationDetail?.email??""}</td>
                                        </tr>
                                        <tr>
                                            <td className={tdStyle2}>Phone</td>
                                            <td className={tdStyle3}>{data?.data?.booking?.DestinationDetail?.phone??""}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="bg-white py-6 px-5 rounded-lg space-y-4">
                            <div className="flex justify-between items-center gap-x-4">
                                <h1 className="font-medium sm:text-2xl text-xl text-themeBlue">
                                    Supplier Details
                                </h1>

                            </div>
                            <div className="block" >
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className={tdStyle2}>Contact Name</td>
                                            <td className={tdStyle3}>{data?.data?.booking?.SupplierDetail?.contactName??""}</td>
                                        </tr>
                                        
                                        <tr>
                                            <td className={tdStyle2}>Tracking No</td>
                                            <td className={tdStyle3}>{data?.data?.booking?.SupplierDetail?.trackingNo??""}</td>
                                        </tr>
                                        <tr>
                                            <td className={tdStyle2}>Tracking Link</td>
                                            <td className={tdStyle3}>{data?.data?.booking?.SupplierDetail?.trackingLink??""}</td>
                                        </tr>
                                        <tr>
                                            <td className={tdStyle2}>Email</td>
                                            <td className={tdStyle3}>{data?.data?.booking?.SupplierDetail?.email??""}</td>
                                        </tr>
                                        <tr>
                                            <td className={tdStyle2}>Phone</td>
                                            <td className={tdStyle3}>{data?.data?.booking?.SupplierDetail?.phone??""}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="bg-white py-6 px-5 rounded-lg space-y-4">
                            <div className="flex justify-between items-center gap-x-4">
                                <h1 className="font-medium sm:text-2xl text-xl text-themeBlue">
                                    Consignee Details
                                </h1>

                            </div>
                            <div className="block" >
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className={tdStyle2}>Company</td>
                                            <td className={tdStyle3}>{data?.data?.booking?.ConsigneeDetail?.companyName??""}</td>
                                        </tr>
                                        <tr>
                                            <td className={tdStyle2}>Contact Name</td>
                                            <td className={tdStyle3}>{data?.data?.booking?.ConsigneeDetail?.contactName??""}</td>
                                        </tr>
                                        <tr>
                                            <td className={tdStyle2}>Country</td>
                                            <td className={tdStyle3}>{data?.data?.booking?.ConsigneeDetail?.country??""}</td>
                                        </tr>
                                        <tr>
                                            <td className={tdStyle2}>Email</td>
                                            <td className={tdStyle3}>{data?.data?.booking?.ConsigneeDetail?.email??""}</td>
                                        </tr>
                                        <tr>
                                            <td className={tdStyle2}>Phone</td>
                                            <td className={tdStyle3}>{data?.data?.booking?.ConsigneeDetail?.phone??""}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="bg-white py-6 px-5 rounded-lg space-y-4">
                            <div className="flex justify-between items-center gap-x-4">
                                <h1 className="font-medium sm:text-2xl text-xl text-themeBlue">
                                    Destination Details
                                </h1>

                            </div>
                            <div className="block" >
                                <table>
                                    <tbody>
                                    <tr>
                                            <td className={tdStyle2}>Company</td>
                                            <td className={tdStyle3}>{data?.data?.booking?.DestinationDetail?.companyName??""}</td>
                                        </tr>
                                        <tr>
                                            <td className={tdStyle2}>Address</td>
                                            <td className={tdStyle3}>{data?.data?.booking?.DestinationDetail?.address??""}</td>
                                        </tr>
                                        <tr>
                                            <td className={tdStyle2}>Country</td>
                                            <td className={tdStyle3}>{data?.data?.booking?.DestinationDetail?.country??""}</td>
                                        </tr>
                                        <tr>
                                            <td className={tdStyle2}>Email</td>
                                            <td className={tdStyle3}>{data?.data?.booking?.DestinationDetail?.email??""}</td>
                                        </tr>
                                        <tr>
                                            <td className={tdStyle2}>Phone</td>
                                            <td className={tdStyle3}>{data?.data?.booking?.DestinationDetail?.phone??""}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>




                    </div>
                    <div className="w-4/5 mx-auto flex justify-end">
                        <div>
                            <button onClick={()=>order_details2()} className="py-3 px-16 border border-themeBlue bg-themeBlue text-white rounded hover:bg-white hover:text-themeBlue">Next</button>
                        </div>
                    </div>
                </section>
            </section>
        </>
    );
}
